import { UserManagementEntityModel } from "src/store/models/entity/userManagement/entity";
import { UserManagementHelperModel } from "src/store/models/entity/userManagement/helper";

export const encooUserManagementModels = {
  entity: UserManagementEntityModel,
  helper: UserManagementHelperModel,
};
